'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isString(value) {
    return typeof value === 'string' || value instanceof String;
}

exports.isString = isString;
